import { FormControl } from '@angular/forms';
import { positiveNotNull } from '../../../../forms/form-control-options.constants';
import { BaseFormControls } from '../../../../forms/form-controls/base.form-controls';

export class QuickHarvestFormControls extends BaseFormControls {
  amountHarvested = new FormControl(1, positiveNotNull);
}
